import React, { createContext, useState, useContext } from 'react';
import config from '../../config';

// Create context
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // For our simplified MVP, we'll use a fixed user
  const fixedUser = {
    username: config.USERNAME,
    attributes: {
      email: `${config.USERNAME}@example.com`,
      name: config.USERNAME
    }
  };

  const [user, setUser] = useState(fixedUser);  // Always authenticated with our fixed user
  const [isLoading, setIsLoading] = useState(false);  // No loading state needed
  const [error, setError] = useState(null);

  // Sign in (simplified for MVP)
  const signIn = () => {
    setUser(fixedUser);
    localStorage.setItem('isAuthenticated', 'true');
    return fixedUser;
  };

  // Sign out (simplified for MVP)
  const signOut = () => {
    localStorage.removeItem('isAuthenticated');
    // In our simplified MVP, we don't actually sign out - we're always the fixed user
    // But we'll redirect to login page for UX consistency
    window.location.href = '/login';
  };

  // Get ID token (simplified for MVP)
  const getIdToken = () => {
    // In a real app, this would return the actual JWT token
    // For our simplified MVP, we just return a dummy token
    return 'dummy-token-for-simplified-mvp';
  };

  const value = {
    user,
    isLoading,
    error,
    signIn,
    signOut,
    getIdToken,
    // Keep the old method name for backward compatibility
    signInWithGoogle: signIn
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

// Custom hook to use the auth context
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
